export var MyTrumpfEnvironmentEnum;
(function (MyTrumpfEnvironmentEnum) {
    MyTrumpfEnvironmentEnum["Development"] = "dev";
    MyTrumpfEnvironmentEnum["Production"] = "prod";
    MyTrumpfEnvironmentEnum["Staging"] = "qa";
})(MyTrumpfEnvironmentEnum || (MyTrumpfEnvironmentEnum = {}));
export var MyTrumpfNotificationSeverityEnum;
(function (MyTrumpfNotificationSeverityEnum) {
    MyTrumpfNotificationSeverityEnum["Error"] = "ERROR";
    MyTrumpfNotificationSeverityEnum["Information"] = "INFORMATION";
    MyTrumpfNotificationSeverityEnum["Warning"] = "WARNING";
})(MyTrumpfNotificationSeverityEnum || (MyTrumpfNotificationSeverityEnum = {}));
//# sourceMappingURL=interface.js.map
